const es = {
  // NAV / HEADER
  "nav.home": "Inicio",
  "nav.catalog": "Catálogo",
  "nav.about": "Nosotros",
  "nav.contact": "Contacto",
  "nav.cart": "Carrito",

  // HERO (usa SOLO las claves nuevas que referencia tu Hero.tsx)
  "hero.title.pre": "Tu Próxima",
  "hero.title.highlight": "Moto",
  "hero.title.post": "Te Está Esperando",
  "hero.subtitle":
    "Descubre nuestra amplia selección de motocicletas nuevas y usadas. Calidad garantizada, financiamiento disponible.",
  "hero.cta.explore": "Ver Catálogo",
  "hero.cta.finance": "Financiamiento",
  "hero.feature.quality": "Calidad Garantizada",
  "hero.feature.warranty": "Garantía Extendida",
  "hero.feature.service": "Servicio Técnico",

  // FEATURES
  "feature.motor": "Motor eléctrico",
  "feature.lightAgile": "Ligero y ágil",
  "feature.batteryHigh": "Batería de alta capacidad",
  "feature.motorHighPower": "Motor eléctrico de alta potencia",
  "feature.touchscreen": "Pantalla táctil",
  "feature.bluetooth": "Conectividad Bluetooth",
  "feature.gps": "Sistema de navegación GPS",

  // CATALOGO / PRODUCTO
  "product.more": "Ver más",
  "product.price": "Precio",
  "product.condition.new": "Nueva",
  "product.condition.used": "Usada",
  "catalog.title": "Nuestro Catálogo",
  "catalog.subtitle":
    "Explora nuestra selección de motocicletas nuevas y usadas. Encontrá la moto perfecta para vos.",
  "catalog.filter.all": "Todas",
  "catalog.filter.new": "Nuevas",
  "catalog.cta.moreBikes": "Ver Más Motos",
  "catalog.toast.moreSoon":
    "Próximamente más motocicletas disponibles. ¡Contactanos para conocer el inventario completo!",
  "product.badge.featured": "Destacada",
  "product.viewDetails": "Ver Detalles",
  "cart.add": "Agregar",
  "product.price.toConfirm": "Consultar precio",
  "image.altFallback": "Imagen no disponible",

  // MODAL
  "modal.close": "Cerrar modal",
  "modal.year": "Año",
  "modal.engine": "Motor",
  "modal.mileage": "Kilometraje",
  "modal.features": "Características",
  "modal.price": "Precio",
  "modal.contact": "Contactar",
  "modal.financing": "Financiamiento",
  "modal.whatsapp": "Consultar por WhatsApp",

  "guarantee.warranty": "Garantía",
  "guarantee.service": "Servicio",
  "guarantee.quality": "Calidad",

  // CONTACTO
  "contact.title": "Contáctanos",
  "contact.whatsapp": "WhatsApp",
  "contact.call": "Llamar",
  "contact.email": "Email",
  "contact.subtitle":
    "¿Tienes alguna pregunta o quieres agendar una cita? Estamos aquí para ayudarte.",
  "contact.info.title": "Información de Contacto",
  "contact.info.address": "Dirección",
  "contact.info.phone": "Teléfono",
  "contact.info.email": "Email",
  "contact.info.hours": "Horarios",
  "contact.info.hoursValue": "Lun - Sáb: 10:00 AM - 7:30 PM\nDom: 10:00 AM - 6:00 PM",

  "contact.map.title": "Visítanos en Nuestra Tienda",
  "contact.map.subtitle":
    "Estamos ubicados en el corazón de la ciudad, con fácil acceso en transporte público.",
  "contact.map.cta": "Ver en Google Maps",

  "contact.whats.cta": "¡Chatea con Nosotros por WhatsApp!",

  "contact.form.title": "Envíanos un Mensaje",
  "contact.form.success": "¡Gracias! Tu mensaje fue enviado.",
  "contact.form.error": "No pudimos enviar tu mensaje. Intentá nuevamente.",
  "contact.form.firstName": "Nombre",
  "contact.form.firstName.placeholder": "Tu nombre",
  "contact.form.lastName": "Apellido",
  "contact.form.lastName.placeholder": "Tu apellido",
  "contact.form.phone": "Teléfono",
  "contact.form.phone.hint": "solo números",
  "contact.form.reason": "Motivo de Contacto",
  "contact.form.reason.info": "Información sobre motos",
  "contact.form.reason.finance": "Financiamiento",
  "contact.form.reason.service": "Servicio técnico",
  "contact.form.reason.warranty": "Garantía",
  "contact.form.reason.other": "Otro",
  "contact.form.message": "Mensaje",
  "contact.form.message.placeholder": "Contanos cómo podemos ayudarte...",
  "contact.form.submit": "Enviar Mensaje",
  "contact.form.sending": "Enviando…",
  "contact.form.sla.title": "Respuesta rápida:",
  "contact.form.sla.body":
    "Nos comprometemos a responder todos los mensajes en menos de 24 horas durante días hábiles.",

  "contact.errors.firstNameRequired": "El nombre es requerido",
  "contact.errors.lastNameRequired": "El apellido es requerido",
  "contact.errors.emailRequired": "El email es requerido",
  "contact.errors.emailInvalid": "Email inválido",
  "contact.errors.phoneRequired": "El teléfono es requerido",
  "contact.errors.phoneInvalid": "Teléfono inválido (10-15 dígitos)",
  "contact.errors.messageRequired": "El mensaje es requerido",

  // FOOTER
  "footer.rights": "Todos los derechos reservados",
  "footer.tagline": "Motos Nuevas y Usadas",
  "footer.desc":
    "Tu tienda de confianza para motocicletas nuevas y usadas. Más de 15 años brindando calidad, servicio y los mejores precios.",
  "footer.quickLinks.title": "Enlaces Rápidos",
  "footer.services.title": "Servicios",
  "services.new": "Motos Nuevas",
  "services.used": "Motos Usadas",
  "services.finance": "Financiamiento",
  "services.tech": "Servicio Técnico",
  "footer.legal.terms": "Términos y Condiciones",
  "footer.legal.privacy": "Política de Privacidad",
  "footer.legal.cookies": "Cookies",
  "footer.legal.termsMsg":
    "Términos y Condiciones: Documento en desarrollo. Para más información, contáctanos.",
  "footer.legal.privacyMsg":
    "Política de Privacidad: Documento en desarrollo. Para más información, contáctanos.",
  "footer.legal.cookiesMsg":
    "Política de Cookies: Documento en desarrollo. Para más información, contáctanos.",
  "social.facebook": "Facebook",
  "social.instagram": "Instagram",
  "social.twitter": "Twitter",
  "social.youtube": "YouTube",

  // GENERALES
  "common.loading": "Cargando...",

  // CART
  "cart.title": "Tu carrito",
  "cart.empty": "No agregaste productos.",
  "cart.total": "Total",
  "cart.clear": "Vaciar",
  "cart.payWithAffirm": "Pagar con Affirm",
  "cart.remove": "Quitar",
  "cart.minus": "Restar",
  "cart.plus": "Sumar",

  // ABOUT
  "about.title": "Sobre Nosotros",
  "about.subtitle":
    "Con más de 15 años de experiencia en el mercado, somos la tienda de motocicletas más confiable de la región. Ofrecemos calidad, servicio y precios competitivos.",

  "about.stats.years": "Años de Experiencia",
  "about.stats.clients": "Clientes Satisfechos",
  "about.stats.support": "Soporte Técnico",
  "about.stats.quality": "Garantía de Calidad",

  "about.trust.title": "Tu Confianza es Nuestra Prioridad",
  "about.trust.p1":
    "En ONE POINT MOTORS, entendemos que comprar una motocicleta es una decisión importante. Por eso, nos comprometemos a brindarte la mejor experiencia de compra, desde la selección hasta el servicio post-venta.",
  "about.trust.p2":
    "Nuestro equipo de expertos está capacitado para ayudarte a encontrar la moto perfecta según tus necesidades y presupuesto. Ofrecemos financiamiento flexible y garantías extendidas para tu tranquilidad.",

  "about.chips.quality": "Calidad Garantizada",
  "about.chips.prices": "Precios Competitivos",
  "about.chips.service": "Servicio Profesional",

  "about.gallery.alt": "Nuestra tienda",
  "about.gallery.prev": "Imagen anterior",
  "about.gallery.next": "Imagen siguiente",
  "about.gallery.seeImage": "Ver imagen {{n}}",

  "about.services.title": "Nuestros Servicios",
  "about.services.new.title": "Venta de Motos Nuevas",
  "about.services.new.desc": "Amplia selección de las mejores marcas del mercado con garantía completa.",
  "about.services.used.title": "Motos Usadas Certificadas",
  "about.services.used.desc": "Motocicletas usadas revisadas y certificadas con garantía extendida.",
  "about.services.fin.title": "Financiamiento Flexible",
  "about.services.fin.desc": "Opciones de financiamiento adaptadas a tu presupuesto y necesidades.",
  "about.services.tech.title": "Servicio Técnico",
  "about.services.tech.desc": "Taller especializado con técnicos certificados y repuestos originales.",
  "about.services.moreInfo": "Más información sobre: {{title}}. ¡Contáctanos para detalles!",
} as const;

export default es;
export type EsDict = typeof es;
